import React, {useEffect} from 'react';
import {V3DApp, Controller, MiniMap, Loading, Message} from "./components";
import VStore from "./store";

function App() {
    const {isLoading, setIsMobile} = VStore();

    useEffect(() => {
        const isMobile = window.innerHeight < 600 || window.innerWidth < 500;
        setIsMobile(isMobile);
    }, []);
  return (
    <div className="App">
        <V3DApp/>
        <Controller/>
        <MiniMap/>
        {
            isLoading && <Loading/>
        }
        <Message/>
    </div>
  );
}

export default App;
